var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebUnknowledgeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Shape",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5461",
    "data-name": "Group 5461",
    transform: "translate(880 -8370)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-box",
    transform: "translate(-872.497 8375.503)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.5, -5.5)",
    filter: "url(#Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M40,0H5A5.015,5.015,0,0,0,0,5V40a5.015,5.015,0,0,0,5,5H40a5.015,5.015,0,0,0,5-5V5a5.015,5.015,0,0,0-5-5Z",
    transform: "translate(9 6)",
    fill: "#1b62c0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "thumb-up",
    transform: "translate(-860 8388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M18.546,21.818H8.728a2.184,2.184,0,0,1-2.182-2.182V8.728A1.818,1.818,0,0,1,7.2,7.2L14.4,0l1.2,1.091a2.312,2.312,0,0,1,.436,1.2v.328L14.946,7.637h6.873A2.184,2.184,0,0,1,24,9.818h-.109V12a1.861,1.861,0,0,1-.109.764L20.51,20.51A2.14,2.14,0,0,1,18.546,21.818Zm-14.183,0H0V8.728H4.363v13.09Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebUnknowledgeIcon);
export default __webpack_public_path__ + "static/media/Web_Unknowledge_Icon.a32dc32339e952d89d44972f42da067d.svg";
export { ForwardRef as ReactComponent };